import { useState, useEffect } from "react";
import { Form, Container, Row, Col } from "react-bootstrap";
import * as S from "./styled";
import api from "../../services/api";
import { useAuth } from "../../context/auth";
import { toast } from "react-toastify";

import Template from "../../template";
import { CPF_OCULTO, formatarCPF, formatarTelefone, soDigitos } from "../../utils/formatadores";

function Main() {
  const { user, isLoadingUser } = useAuth();

  useEffect(() => {
    if (!user?.nivel) return;

    const role =
      user.nivel === "a" ? "ADM" :
      user.nivel === "c" ? "CORRETOR" :
      user.nivel === "e" ? "ESTUDANTE" :
      user.nivel === "t" ? "TESTE" :
      `DESCONHECIDO (${user.nivel})`;

    console.log(`%cTipo de usuário: ${role}`, 'color: white; background-color: darkblue; padding: 2px 5px; border-radius: 2px;');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // roda só 1 vez

  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [cpf, setCPF] = useState("");
  const [totalFeitas, setTotalFeitas] = useState(0);
  const [salvando, setSalvando] = useState(false);

  /*
    Troca de senha em modal próprio: é outra operação, com outra confirmação e
    outro risco. Misturada ao formulário de dados, a tela dava a entender que a
    senha atual era exigida para editar nome/email — e nem era enviada ao backend.
  */
  /*
    Rascunho separado do que está na tela: o modal só grava no estado exibido
    depois que a API confirma, então cancelar não deixa a tela mentindo.
  */
  const [modalDados, setModalDados] = useState(false);
  const [verCpf, setVerCpf] = useState(false);
  const [rascunho, setRascunho] = useState({ nome: "", email: "", telefone: "" });

  const [modalSenha, setModalSenha] = useState(false);
  const [senhaAtual, setSenhaAtual] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [confirmaNova, setConfirmaNova] = useState("");
  const [verSenha, setVerSenha] = useState({ atual: false, nova: false, confirma: false });
  const [erroSenha, setErroSenha] = useState("");
  const [trocando, setTrocando] = useState(false);

  /*
    Requisitos avaliados um a um (e não por uma regex única) para a tela poder
    dizer o que falta, em vez de só recusar no envio.
  */
  const REQUISITOS = [
    { texto: "6+ caracteres", ok: novaSenha.length >= 6 },
    { texto: "1 maiúscula", ok: /[A-Z]/.test(novaSenha) },
    { texto: "1 minúscula", ok: /[a-z]/.test(novaSenha) },
    { texto: "1 número", ok: /\d/.test(novaSenha) },
    { texto: "1 símbolo", ok: /[\W_]/.test(novaSenha) },
  ];

  const senhaValida = REQUISITOS.every((r) => r.ok);
  const confirmaConfere = confirmaNova.length > 0 && novaSenha === confirmaNova;
  const podeTrocar = senhaAtual.length > 0 && senhaValida && confirmaConfere;

  function abrirModalDados() {
    setRascunho({ nome, email, telefone: formatarTelefone(telefone) });
    setModalDados(true);
  }

  async function atualizarCadastro(e) {
    e?.preventDefault?.();

    if (rascunho.nome.trim().length < 2) {
      toast.error("Informe seu nome completo.");
      return;
    }

    setSalvando(true);

    try {
      await api.post("/changePerfil", {
        name: rascunho.nome.trim(),
        email: rascunho.email.trim(),
        /* O backend espera `phone`; mandar `telefone` fazia o campo nunca ser salvo. */
        phone: soDigitos(rascunho.telefone),
      });

      setNome(rascunho.nome.trim());
      setEmail(rascunho.email.trim());
      setTelefone(soDigitos(rascunho.telefone));
      setModalDados(false);
      toast.success("Dados atualizados com sucesso.");
    } catch (error) {
      const detalhe = error?.response?.data?.errors?.[0]?.message;

      toast.error(detalhe || error?.response?.data?.message || "Não foi possível atualizar seus dados.");
    } finally {
      setSalvando(false);
    }
  }

  function abrirModalSenha() {
    setSenhaAtual("");
    setNovaSenha("");
    setConfirmaNova("");
    setErroSenha("");
    setVerSenha({ atual: false, nova: false, confirma: false });
    setModalSenha(true);
  }

  async function trocarSenha(e) {
    e?.preventDefault?.();

    /* O botão só habilita com tudo válido; os indicadores mostram o que falta. */
    if (!podeTrocar) return;

    setTrocando(true);
    setErroSenha("");

    try {
      const { data } = await api.post("/alterar-senha", { senhaAtual, novaSenha });

      toast.success(data.message);
      setModalSenha(false);
    } catch (error) {
      /* 401 aqui é senha atual errada, não sessão expirada. */
      const msg = error?.response?.data?.message
        || error?.response?.data?.errors?.[0]?.message
        || "Não foi possível alterar a senha.";

      setErroSenha(msg);
    } finally {
      setTrocando(false);
    }
  }

  useEffect(() => {

    

    async function getPerfil() {
      try {
        let response = await api.get("/meuperfil");

        setNome(response.data.name);
        setEmail(response.data.email);
        setTelefone(response.data.phone);
        setCPF(response.data.cpf);
      } catch (err) {}
    }

    async function getRedacoes() {
      try {
        let response = await api.get(`/redacoes`);

        setTotalFeitas(response.data[0].total);
      } catch (err) {}
    }

    getRedacoes();
    getPerfil();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Template>
      <S.MainWrapper>
        <Container fluid style={{padding: '15px 15px', margin: 0}}>
          <Row style={{margin: 0}}>
            <Col sm={12} style={{padding: 0}}>
              <S.MainContent style={{borderRadius: '25px', overflow: 'hidden'}}>
                <S.PageHeader>
                  <S.WelcomeTitle>Seja bem-vindo(a)</S.WelcomeTitle>
                  <S.UserName>{user.nome}</S.UserName>
                </S.PageHeader>
                
                <div style={{padding: '30px'}}>
                  <Row>
                    <Col sm={['PREMIUM', 'VIP', 'PLUS', 'ESSENCIAL'].includes(user.plano) ? 4 : 6}>
                      <S.StatsCard>
                        <div className="card-header">REDAÇÕES</div>
                        <div className="card-body">
                          <div className="card-title">{totalFeitas}</div>
                          <div className="card-text">
                            Redações realizadas até agora
                          </div>
                          {!isLoadingUser && user && user.nivel !== 't' && user.nivel !== 'c' && (
                            <div style={{marginTop: '15px'}}>
                              <a href="/minhas-redacoes" style={{
                                background: '#024995',
                                color: 'white',
                                textDecoration: 'none',
                                padding: '10px 20px',
                                borderRadius: '20px',
                                fontSize: '14px',
                                fontWeight: '600',
                                display: 'inline-block',
                                transition: 'all 0.3s ease',
                                boxShadow: '0 4px 15px rgba(2, 73, 149, 0.3)'
                              }}
                              onMouseOver={(e) => {
                                e.target.style.transform = 'translateY(-2px)';
                                e.target.style.boxShadow = '0 6px 20px rgba(2, 73, 149, 0.4)';
                              }}
                              onMouseOut={(e) => {
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = '0 4px 15px rgba(2, 73, 149, 0.3)';
                              }}>
                                Ver Minhas Redações
                              </a>
                            </div>
                          )}
                        </div>
                      </S.StatsCard>
                    </Col>
                    <Col sm={['PREMIUM', 'VIP', 'PLUS', 'ESSENCIAL'].includes(user.plano) ? 4 : 6}>
                       <S.StatsCard>
                         <div className="card-header">EVOLUÇÃO</div>
                         <div className="card-body">
                           <div className="card-title">Minhas Médias</div>
                           <div className="card-text">
                             Acompanhe seu desempenho por competência
                           </div>
                           {!isLoadingUser && user && user.nivel !== 't' && user.nivel !== 'c' && (
                             <div style={{marginTop: '15px'}}>
                               <a href="/medias" style={{
                                 background: '#009bd9',
                                 color: 'white',
                                 textDecoration: 'none',
                                 padding: '10px 20px',
                                 borderRadius: '20px',
                                 fontSize: '14px',
                                 fontWeight: '600',
                                 display: 'inline-block',
                                 transition: 'all 0.3s ease',
                                 boxShadow: '0 4px 15px rgba(0, 155, 217, 0.3)'
                               }}
                               onMouseOver={(e) => {
                                 e.target.style.transform = 'translateY(-2px)';
                                 e.target.style.boxShadow = '0 6px 20px rgba(0, 155, 217, 0.4)';
                               }}
                               onMouseOut={(e) => {
                                 e.target.style.transform = 'translateY(0)';
                                 e.target.style.boxShadow = '0 4px 15px rgba(0, 155, 217, 0.3)';
                               }}>
                                 Ver Minhas Médias
                               </a>
                             </div>
                           )}
                         </div>
                       </S.StatsCard>
                     </Col>
                     {['PREMIUM', 'VIP', 'PLUS', 'ESSENCIAL'].includes(user.plano) && (
                     <Col sm={4}>
                       <S.StatsCard>
                         <div className="card-header">ASSINATURA</div>
                         <div className="card-body">
                           <div className="card-title">
                             {user.data_limite ? new Date(user.data_limite).toLocaleDateString('pt-BR') : 'Nenhum plano ativo'}
                           </div>
                           <div className="card-text">
                             Data de vencimento do seu plano
                           </div>
                           {user.data_limite && (
                             <div style={{marginTop: '15px'}}>
                               <span style={{
                                 background: new Date(user.data_limite) > new Date() 
                                   ? '#28a745' 
                                   : '#dc3545',
                                 color: 'white',
                                 padding: '8px 16px',
                                 borderRadius: '15px',
                                 fontSize: '12px',
                                 fontWeight: '600',
                                 display: 'inline-block'
                               }}>
                                 {new Date(user.data_limite) > new Date() ? 'Ativo' : 'Vencido'}
                               </span>
                             </div>
                           )}
                         </div>
                       </S.StatsCard>
                     </Col>
                     )}
                  </Row>
                </div>
              </S.MainContent>

              <S.FormCard>
                <S.FormHeader>
                  <S.FormTitle style={{ margin: 0 }}>Dados cadastrais</S.FormTitle>
                  <S.AcoesCabecalho>
                    <S.BotaoEditar type="button" onClick={abrirModalDados}>
                      <i className="fas fa-pen" /> Alterar dados cadastrais
                    </S.BotaoEditar>
                    <S.BotaoSenha type="button" onClick={abrirModalSenha}>
                      <i className="fas fa-key" /> Alterar senha
                    </S.BotaoSenha>
                  </S.AcoesCabecalho>
                </S.FormHeader>

                <S.ListaDados>
                  <S.ItemDado>
                    <dt>Nome</dt>
                    <dd>{nome || <span className="vazio">Não informado</span>}</dd>
                  </S.ItemDado>

                  <S.ItemDado>
                    <dt>E-mail</dt>
                    <dd>{email || <span className="vazio">Não informado</span>}</dd>
                  </S.ItemDado>

                  <S.ItemDado>
                    <dt>CPF</dt>
                    <dd>
                      {cpf ? (
                        <S.ValorComOlho>
                          <span className="valor">{verCpf ? formatarCPF(cpf) : CPF_OCULTO}</span>
                          <button
                            type="button"
                            onClick={() => setVerCpf((v) => !v)}
                            aria-label={verCpf ? "Ocultar CPF" : "Mostrar CPF"}
                            title={verCpf ? "Ocultar CPF" : "Mostrar CPF"}
                          >
                            <i className={verCpf ? "fas fa-eye-slash" : "fas fa-eye"} />
                          </button>
                        </S.ValorComOlho>
                      ) : (
                        <span className="vazio">Não informado</span>
                      )}
                    </dd>
                  </S.ItemDado>

                  <S.ItemDado>
                    <dt>Telefone</dt>
                    <dd>
                      {telefone ? formatarTelefone(telefone) : <span className="vazio">Não informado</span>}
                    </dd>
                  </S.ItemDado>
                </S.ListaDados>
              </S.FormCard>
            </Col>
          </Row>
        </Container>
      </S.MainWrapper>

      {modalDados && (
        <S.Overlay onClick={() => !salvando && setModalDados(false)}>
          <S.Dialogo onClick={(e) => e.stopPropagation()}>
            <S.DialogoTopo>
              <div className="icone">
                <i className="fas fa-pen" />
              </div>
              <div>
                <h3>Alterar dados cadastrais</h3>
                <p>O CPF não pode ser alterado</p>
              </div>
            </S.DialogoTopo>

            <form onSubmit={atualizarCadastro}>
              <S.DialogoCorpo>
                {[
                  { chave: "nome", rotulo: "Nome", ph: "Digite seu nome completo", tipo: "text" },
                  { chave: "email", rotulo: "E-mail", ph: "Digite seu e-mail", tipo: "email" },
                  { chave: "telefone", rotulo: "Telefone", ph: "(00) 00000-0000", tipo: "text" },
                ].map((campo) => (
                  <S.CampoSenha key={campo.chave}>
                    <label>{campo.rotulo}</label>
                    <div className="entrada">
                      <input
                        type={campo.tipo}
                        value={rascunho[campo.chave]}
                        disabled={salvando}
                        placeholder={campo.ph}
                        style={{ paddingRight: 13 }}
                        onChange={(e) =>
                          setRascunho((r) => ({
                            ...r,
                            [campo.chave]:
                              campo.chave === "telefone"
                                ? formatarTelefone(e.target.value)
                                : e.target.value,
                          }))
                        }
                      />
                    </div>
                  </S.CampoSenha>
                ))}

                <S.RegraSenha>
                  O e-mail é usado para entrar na plataforma — confira antes de salvar.
                </S.RegraSenha>
              </S.DialogoCorpo>

              <S.DialogoAcoes>
                <S.BotaoCancelar type="button" disabled={salvando} onClick={() => setModalDados(false)}>
                  Cancelar
                </S.BotaoCancelar>
                <S.BotaoConfirmar type="submit" disabled={salvando}>
                  {salvando ? "Salvando..." : "Salvar alterações"}
                </S.BotaoConfirmar>
              </S.DialogoAcoes>
            </form>
          </S.Dialogo>
        </S.Overlay>
      )}

      {modalSenha && (
        <S.Overlay onClick={() => !trocando && setModalSenha(false)}>
          <S.Dialogo onClick={(e) => e.stopPropagation()}>
            <S.DialogoTopo>
              <div className="icone">
                <i className="fas fa-key" />
              </div>
              <div>
                <h3>Alterar senha</h3>
                <p>Confirme a senha atual para definir uma nova</p>
              </div>
            </S.DialogoTopo>

            <form onSubmit={trocarSenha}>
              <S.DialogoCorpo>
                {[
                  { chave: "atual", rotulo: "Senha atual", valor: senhaAtual, set: setSenhaAtual, ph: "Digite sua senha atual" },
                  { chave: "nova", rotulo: "Nova senha", valor: novaSenha, set: setNovaSenha, ph: "Digite a nova senha" },
                  { chave: "confirma", rotulo: "Confirmar nova senha", valor: confirmaNova, set: setConfirmaNova, ph: "Repita a nova senha" },
                ].map((campo) => (
                  <S.CampoSenha key={campo.chave}>
                    <label>{campo.rotulo}</label>
                    <div className="entrada">
                      <input
                        type={verSenha[campo.chave] ? "text" : "password"}
                        value={campo.valor}
                        disabled={trocando}
                        placeholder={campo.ph}
                        onChange={(e) => {
                          campo.set(e.target.value);
                          if (erroSenha) setErroSenha("");
                        }}
                      />
                      <button
                        type="button"
                        className="olho"
                        tabIndex={-1}
                        aria-label={verSenha[campo.chave] ? "Ocultar senha" : "Mostrar senha"}
                        onClick={() =>
                          setVerSenha((v) => ({ ...v, [campo.chave]: !v[campo.chave] }))
                        }
                      >
                        <i className={verSenha[campo.chave] ? "fas fa-eye-slash" : "fas fa-eye"} />
                      </button>
                    </div>

                    {campo.chave === "nova" && novaSenha.length > 0 && (
                      <S.Requisitos>
                        {REQUISITOS.map((req) => (
                          <S.Requisito key={req.texto} $ok={req.ok}>
                            <i className={req.ok ? "fas fa-check" : "fas fa-xmark"} />
                            {req.texto}
                          </S.Requisito>
                        ))}
                      </S.Requisitos>
                    )}

                    {campo.chave === "confirma" && confirmaNova.length > 0 && (
                      <S.Conferencia $ok={confirmaConfere}>
                        <i className={confirmaConfere ? "fas fa-check" : "fas fa-xmark"} />
                        {confirmaConfere ? "As senhas conferem" : "As senhas não conferem"}
                      </S.Conferencia>
                    )}
                  </S.CampoSenha>
                ))}

                {erroSenha && <S.ErroSenha>{erroSenha}</S.ErroSenha>}
              </S.DialogoCorpo>

              <S.DialogoAcoes>
                <S.BotaoCancelar type="button" disabled={trocando} onClick={() => setModalSenha(false)}>
                  Cancelar
                </S.BotaoCancelar>
                <S.BotaoConfirmar type="submit" disabled={trocando || !podeTrocar}>
                  {trocando ? "Alterando..." : "Alterar senha"}
                </S.BotaoConfirmar>
              </S.DialogoAcoes>
            </form>
          </S.Dialogo>
        </S.Overlay>
      )}
    </Template>
  );
}

export default Main;
